import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'tovieos.density'

export type Density = 'comfortable' | 'compact'

export function getInitialDensity(): Density {
  if (typeof window === 'undefined') return 'comfortable'
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'compact'
      ? 'compact'
      : 'comfortable'
  } catch {
    return 'comfortable'
  }
}

export function applyDensity(d: Density) {
  if (typeof document === 'undefined') return
  document.body.classList.toggle('compact', d === 'compact')
}

export function useDensity() {
  const [density, setDensity] = useState<Density>(getInitialDensity)

  useEffect(() => {
    applyDensity(density)
    try {
      window.localStorage.setItem(STORAGE_KEY, density)
    } catch { /* ignore quota / private-mode */ }
  }, [density])

  const toggle = useCallback(() => {
    setDensity((d) => (d === 'compact' ? 'comfortable' : 'compact'))
  }, [])

  return { density, setDensity, toggle }
}
